import { rule } from '../../domain/badge-composition-rule.js';

/**
 * @param {BadgeComposition} composition
 * @returns {BadgeCompositionRule[]}
 */
export const sandboxRules = composition => {
  const { sandboxEnvironment } = composition.checkers;

  return [
    rule('sandbox/watermarks')
      .when(sandboxEnvironment)
      .set(() => ({
        parts: {
          aubySeal: {
            imageSrc: 'authorized-by-badge_demo.svg',
          },
          tuvSeal: {
            imageSrc: 'tuev-badge_demo.svg'
          },
        }
      })),
  ];
};
